import PageItemsApi from '@/services/api/page.api'


export default {
    namespaced: true,
    state: {
        items: [],
        userName: "",
        userCause: "",
        userStrength: "",
        //loading: true
      },
      getters: {
          userName: state => state.userName,
          userCause: state => state.userCause,
          userStrength: state => state.userStrength
      },
      mutations: {
          SET_PAGE_ITEMS (state, items) {
              state.items = items.data
          },
          SET_USER_NAME (state, name) {
              state.userName = name
          },
          SET_USER_CAUSE (state, cause) {
            state.userCause = cause
          },
          SET_USER_STRENGTH (state, strength) {
            state.userStrength = strength
          }
          // SET_LOADING_STATE (state, status) {
          //   //console.log("setting load state: ", status)
          //   state.loading = status
          // }
      },
      actions: {
          GET_ITEMS ({commit}) {
            PageItemsApi.getPageItems()
              .then(items => {
                  commit('SET_PAGE_ITEMS', items)
              })
              // eslint-disable-next-line no-console
              .catch(error => console.log(error))
              .finally(() => {
                  //commit('SET_LOADING_STATE', false)
            })
          },
          POPULATE_USER_NAME ({commit}, name) {
              commit('SET_USER_NAME', name)
          },
          POPULATE_USER_CAUSE ({commit}, cause) {
            commit('SET_USER_CAUSE', cause)
          },
          POPULATE_USER_STRENGTH ({commit}, strength) {
            commit('SET_USER_STRENGTH', strength)
        }
      }
}
